import * as React from 'react';
import { DocumentTitle } from '../core/DocumentTitle';
import PodPlaceholder from './PodPlaceholder';

interface Props {
  children?: React.ReactNode;
}

export interface State {
  error?: Error;
}

class PodErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    if (this.state.error) {
      return (
        <>
          <PodPlaceholder
            type='error'
            iconName='Embed'
            text='An unexpected error occurred.'
            output={`${this.state.error.message}${'\n\n'}${this.state.error.stack}`}
          />
          <DocumentTitle title='Error'/>
        </>
      );
    }
    return this.props.children as JSX.Element;
  }

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }
}

export default PodErrorBoundary;
